<template>
    <b-modal
        id="documentPackModal"
        :title="carrier + ' Document Pack'"
        @ok="handleOk"
        @cancel="reset"
        @hidden="reset"
    >
        <form ref="form" @submit.stop.prevent="handleOk">
            <b-form-group>

                <b-row class="mt-3">
                    <b-col>
                        <b-form-group :label="$t('core.documentPack.ChooseBranches')">
                            <b-form-checkbox-group
                                stacked
                                v-model="selectedBranchIds"
                                name="documentPackGroup"
                            >
                                <b-form-checkbox
                                    v-for="branch in branches"
                                    :key="branch.value"
                                    :value="branch.id"
                                >
                                    <span class="align-middle">{{ branch.name }}</span>
                                </b-form-checkbox>
                            </b-form-checkbox-group>

                            <div class="mt-3" v-if="branches.length > 1">
                                <a href="#" @click="selectAll" name="documentPackSelectAll">{{
                                    $t('core.dailyManifest.SelectAll')
                                }}</a>
                                <a
                                    href="#"
                                    class="ml-2"
                                    @click="deselectAll"
                                    name="documentPackDeselectAll"
                                    >{{ $t('core.dailyManifest.DeselectAll') }}</a
                                >
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-invalid-feedback
                name="manifestInvalidFeedback"
                v-if="invalidFeedback"
                :state="state"
            >
                {{ invalidFeedback }}
            </b-form-invalid-feedback>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">
                Cancel
            </b-button>
            <b-button @click="ok()" variant="primary" name="documentPackDownload">
                {{ $t('core.documentPack.DownloadDocumentPack') }}
                <b-spinner v-if="spinnerLoading" small></b-spinner>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import vSelect from './vSelect';
import Datepicker from 'vuejs-datepicker';
import { ACTIONS, MUTATIONS, CORE_PREFIX } from '../store/constants';

export default {
    components: {
        vSelect,
        Datepicker
    },
    data() {
        return {
            disabledDates: { from: new Date() },
            invalidFeedback: '',
            state: null,
            spinnerLoading: false,
            accounts: [],
            selectedBranchIds: [],
            carrier: 'N/A'
        };
    },

    props: {
        branches: { required: true, type: Array }
    },

    methods: {
        handleOk(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.getDocumentPack();
        },
        selectAll() {
            this.branches.forEach((x) => {
                this.selectedBranchIds.push(x.id);
            });
        },
        deselectAll() {
            this.selectedBranchIds = [];
        },
        async getDocumentPack() {
            if (this.selectedBranchIds.length === 0) {
                this.state = false;
                this.invalidFeedback = 'Please select atleast one branch';
                return;
            }

            this.spinnerLoading = true;

            const request = {
                branchIds: this.selectedBranchIds, carrier: this.carrier
            }

            const response = await this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.CREATE_DOCUMENT_PACK, request);
            
            if (response.error) {
                this.invalidFeedback = response.error;
                this.state = false;
            } else {
                this.$bvModal.hide('documentPackModal');
                window.open(response.url, '_blank');
            }

            this.spinnerLoading = false;
        },

        showDocumentPackModal(carrier) {
            this.carrier = carrier;
            this.branches.forEach((element) => {
                this.selectedBranchIds.push(element.id);
            });

            this.$bvModal.show('documentPackModal');
        },

        reset() {
            this.state = null;
            this.invalidFeedback = '';
            this.spinnerLoading = false;
            this.selectedBranchIds = [];
        }
    }
};
</script>
